import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { KYMW1320Component } from './kymw1320.component';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { SaveInspectListService } from './api-services/save-inspect-list.service';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';

/**
 * プロモ商品企画点検リスト画面　モジュール設定クラス
 *
 * @export KYMW1320Module
 * @class KYMW1320Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW1320Component,
  ],
  providers: [
    SaveInspectListService,
    FileDownloadConfirmService,
  ],
})

export class KYMW1320Module { }
